export const VegetationStages = {

    VEGETATION_STAGE_1: {text: 'Rosettenstadium', value: 'vegetationStage1'},
    VEGETATION_STAGE_2: {text: 'Jugendstadium', value: 'vegetationStage2'},
    VEGETATION_STAGE_3: {text: 'Blüte', value: 'vegetationStage3'},
    VEGETATION_STAGE_4: {text: 'Fruchtstadium', value: 'vegetationStage4'},
    VEGETATION_STAGE_5: {text: 'Winterstadium', value: 'vegetationStage5'},
    VEGETATION_STAGE_6: {text: 'Jungbaum', value: 'vegetationStage6'},
    VEGETATION_STAGE_7: {text: 'Baum', value: 'vegetationStage7'},

    list() {
        return [
            this.VEGETATION_STAGE_1,
            this.VEGETATION_STAGE_2,
            this.VEGETATION_STAGE_3,
            this.VEGETATION_STAGE_4,
            this.VEGETATION_STAGE_5,
            this.VEGETATION_STAGE_6,
            this.VEGETATION_STAGE_7,
        ]
    },

    itemByValue(value) {
        let vegetationStage = this.list().find(vegetationStage => vegetationStage.value === value)
        return typeof(vegetationStage)==="undefined"? false: vegetationStage
    }

}
